export default __webpack_public_path__ + "static/logo-header-black-890b6cc21b32d42d49d534568ab43d55.png";